module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Kindle.aaffe157.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Kindle.svg
// module id = 1618
// module chunks = 0